import {IGlobalStore} from 'modules/types';
import {EnumRegion} from 'modules/utils';


export const getBeTimeDiff = ({ settings }: IGlobalStore): number =>  settings.be_time_diff;
export const isRegionConfigured = ({ settings }: IGlobalStore): boolean =>  settings.is_region_configured;
export const getRegionSelector = ({ settings }: IGlobalStore): EnumRegion =>  settings.region;
